import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as moment from 'moment';

import Calendar from './Calendar';

enum Stage { SHOW, PICK }

interface P {
    name?: string;
    placeholder?: string;
    today?: moment.Moment;
    epoch?: moment.Moment;
    value?: moment.Moment;
    onChange?: (date: moment.Moment) => void;
}

interface S {
    stage: Stage;
}

export default class DatePicker extends React.Component<P, S> {

    private today_: moment.Moment;
    private sense_: (e: Event) => void;

    constructor( props: P, context: any ) {
        super( props, context );

        this.today_ = moment();
        this.sense_ = ( e: Event ) => {
            if ( !ReactDOM.findDOMNode(this).contains(e.target as Node) )
                this.deactivate();
        };
        this.state = { stage: Stage.SHOW };
    }

    private get today(): moment.Moment {
        return this.props.today || this.today_;
    }

    private activate() {
        this.setState({ stage: Stage.PICK });
    }

    private deactivate() {
        this.setState({ stage: Stage.SHOW });
    }

    componentWillMount() {
        document.addEventListener('click', this.sense_, false);
        document.addEventListener('focus', this.sense_, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.sense_, false);
        document.removeEventListener('focus', this.sense_, true);
    }

    private pick( date: moment.Moment ) {
        this.setState({ stage: Stage.SHOW });

        if ( this.props.onChange )
            this.props.onChange( date );
    }

    render() {
        let value = ( this.props.value &&
                      this.props.value.format('YYYY-MM-DD') );

        let className = [ 'datepicker', 'component' ];
        if ( Stage.PICK === this.state.stage )
            className.unshift( 'active' );

        return (
            <div className={ className.join(' ') }>
              <input type="text"
                     name={ this.props.name }
                     value={ value || '' }
                     placeholder={ this.props.placeholder }
                     readOnly
                     onFocus={ () => this.activate() } />
              <Calendar value={ this.props.value }
                        today={ this.today }
                        epoch={ this.props.epoch || this.today }
                        onChange={ date => this.pick(date) } />
            </div>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/widgets/DatePicker.tsx
 **/